module.exports = __webpack_public_path__ + "img/material-ui.294d56d7.png";